/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type TemplateQuoteTemplateVersionMenu_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null };

export const TemplateQuoteTemplateVersionMenu_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuoteTemplateVersionMenu_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
}
    `;